import {Flex, Progress, Text} from '@chakra-ui/react'

const LessonProgress = ({
  currentIndex,
  data,
}: {
  currentIndex: any
  data: any
}) => {
  if (!data) {
    return <></>
  }

  return (
    <Flex
      flexShrink={1}
      mt={'24px'}
      px={{base: '16px', lg: 0}}
      justifyContent={'center'}
      maxW={'1000px'}
      w={'100%'}
      mx={'auto'}
      alignItems={'center'}
      gap={'16px'}>
      <Text fontSize={'20px'} fontWeight={600}>
        {`${currentIndex}/${data?.length}`}
      </Text>
      <Progress
        bg={'#e4e4e4'}
        flexGrow={1}
        value={(currentIndex / data?.length) * 100}
        borderRadius={'20px'}
        sx={{
          '[role="progressbar"]': {
            backgroundColor: '#F2C94C',
          },
        }}
      />
    </Flex>
  )
}

export default LessonProgress
